import styled from 'styled-components'

export const TabsListStyle = {
  borderBottom: `1px solid var(--border-tertiary)`,
  marginBottom: 'var(--space-400)',
}
export const TabsItemStyle = {
  fontWeight: 'var(--font-weight-semibold)',
  paddingBottom: 'var(--space-150)',
  whiteSpace: 'nowrap',
}

export const LoaderContainer = styled.div`
  margin-top: var(--space-400);
  display: flex;
  justify-content: center;
`
